import { MotionValue, useTransform } from 'framer-motion';
import { PICTOGRAM_SCALE_START, TITLE_SCALE_START } from './ecosystem-phases';

const META_DESCRIPTION_MARGIN = 32;
const DESCRIPTION_Y_FACTOR = 0.5;
const TITLE_Y_FACTOR = DESCRIPTION_Y_FACTOR * 3.5;

export function useEcosystemItemMetaMotion(
    pictogramScale: MotionValue<number>,
    titleHeight: number,
    descriptionOpacity: MotionValue<number>,
    scrollYProgress: MotionValue<number>,
) {
    const titleScale = useTransform(pictogramScale, [PICTOGRAM_SCALE_START, 1], [TITLE_SCALE_START, 1]);
    const titleY = useTransform(titleScale, (scale) => -titleHeight * 0.6 * TITLE_Y_FACTOR * (1 - scale));
    const descriptionY = useTransform(
        titleScale,
        (scale) => -(titleHeight + META_DESCRIPTION_MARGIN) * TITLE_Y_FACTOR * (1 - scale),
    );
    const iconOpacity = useTransform(scrollYProgress, [0.5, 0.8], [0, 1]);

    return { titleScale, titleY, descriptionY, descriptionOpacity, iconOpacity };
}
